import { defineMessages } from "react-intl";

export default defineMessages({
  asianhallinta: {
    id: "kebabCase.asianhallinta",
    defaultMessage: "asianhallinta"
  },
  avoimet: {
    id: "kebabCase.avoimet",
    defaultMessage: "avoimet"
  },
  jarjestamisJaYllapitamisluvat: {
    id: "kebabCase.jarjestamisJaYllapitamisluvat",
    defaultMessage: "jarjestamis-ja-yllapitamisluvat"
  },
  jarjestamislupa: {
    id: "kebabCase.jarjestamislupa",
    defaultMessage: "jarjestamislupa"
  },
  // Oiva-daily August 6, 2026: This route (jarjestamislupaasiat) is most likely dead code left over from
  // removing a feature where education organizers could manage their permits.
  // Only referenced from wizardUtils.ts (role === "KJ") and Jarjestaja/index.jsx
  // (tab shown when the logged-in user is the jarjestaja themselves), and no
  // <Route> is registered for it in Asianhallinta/index.jsx.
  jarjestamislupaasiat: {
    id: "kebabCase.jarjestamislupaasiat",
    defaultMessage: "jarjestamislupa-asiat"
  },
  koulutustoimijat: {
    id: "kebabCase.koulutustoimijat",
    defaultMessage: "koulutustoimijat"
  },
  paatetyt: {
    id: "kebabCase.paatetyt",
    defaultMessage: "paatetyt"
  },
  paatokset: {
    id: "kebabCase.paatokset",
    defaultMessage: "paatokset"
  },
  tilastot: {
    id: "kebabCase.tilastot",
    defaultMessage: "tilastot"
  },
  uusi: {
    id: "kebabCase.uusi",
    defaultMessage: "uusi"
  }
});
